<template>
  <van-overlay :show="show" z-index="999" class="guideOverlay">
    <div class="guideWrap" @touchmove.stop>
      <div class="guideCard" @click.stop>
        <div class="guideTitle">{{ guide.title }}</div>
        <div class="guideDesc">{{ guide.desc }}</div>
        <div class="guideDivider"></div>
        <div class="guideSteps">
          <div
            class="guideStep"
            v-for="(step, index) in guide.steps"
            :key="index"
          >
            <div class="stepIndex">{{ index + 1 }}</div>
            <div class="stepText">
              <div class="stepTitle">{{ step.title }}</div>
              <div class="stepDesc">{{ step.desc }}</div>
            </div>
          </div>
        </div>
        <div class="guideNotice">{{ guide.notice }}</div>
        <div class="guideConfirm" @click="$emit('close')">我知道了</div>
        <div class="guideHelp" @click.stop="$emit('help', $event)">
          安装遇到问题？查看常见问题
        </div>
      </div>
      <div class="guideClose" @click.stop="$emit('close')"></div>
    </div>
  </van-overlay>
</template>

<script>
const GUIDES = {
  ios: {
    title: "安装 iOS 轻量版",
    desc: "免 App Store，三步完成，约 1 分钟",
    steps: [
      {
        title: "允许下载描述文件",
        desc: "在 Safari 中点击「苹果下载」，系统提示时选择「允许」。"
      },
      {
        title: "安装描述文件",
        desc:
          "前往「设置」，点击顶部「已下载描述文件」，选择「安装」并输入锁屏密码。"
      },
      {
        title: "返回桌面打开",
        desc: "桌面出现「黄果短剧」图标后，点开即可观看。"
      }
    ],
    notice:
      "仅支持 Safari；在微信或 Telegram 内请先点右上角，选择「在浏览器中打开」。"
  },
  android: {
    title: "安装 Android 版",
    desc: "下载 APK，三步完成",
    steps: [
      {
        title: "下载安装包",
        desc: "点击下载按钮，下载完成后在通知栏或下载列表点击打开。"
      },
      {
        title: "允许安装未知来源",
        desc: "提示「禁止安装来源不明的应用」时，点「设置」开启允许后返回安装。"
      },
      {
        title: "打开黄果短剧",
        desc: "安装完成后点击「打开」，或在桌面找到「黄果短剧」图标。"
      }
    ],
    notice: "安装时如提示风险，属于安全软件误报，可放心继续安装。"
  }
};

export default {
  name: "InstallGuide",
  props: {
    show: Boolean,
    type: {
      type: String,
      default: "android"
    }
  },
  computed: {
    guide() {
      return this.type === "ios" ? GUIDES.ios : GUIDES.android;
    }
  }
};
</script>

<style lang="scss" scoped>
.guideOverlay {
  padding: 16px 0;
  padding-top: calc(16px + env(safe-area-inset-top));
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  font-family: "PingFang SC", -apple-system, "Helvetica Neue", Arial, sans-serif;
  color: #f2f2f4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 11, 13, 0.9);
}

.guideWrap {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.guideCard {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 311px;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 16px;
  background: #1b1b1f;

  > * {
    flex-shrink: 0;
  }

  .guideTitle {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
  }

  .guideDesc {
    width: 100%;
    color: #6b6b74;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }

  .guideDivider {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.06);
  }

  .guideSteps {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .guideStep {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
  }

  .stepIndex {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 999px;
    background: rgba(236, 35, 127, 0.16);
    color: #ff4a7b;
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .stepText {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .stepTitle {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .stepDesc {
    color: #b9bbc2;
    font-size: 12px;
    line-height: 18px;
  }

  .guideNotice {
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    color: #6b6b74;
    font-size: 12px;
    line-height: 18px;
  }

  .guideConfirm {
    width: 100%;
    height: 44px;
    margin-top: 8px;
    border-radius: 999px;
    background: linear-gradient(135deg, #ff4a7b 0%, #ec237f 52%, #93226f 100%);
    font-size: 16px;
    font-weight: 500;
    line-height: 44px;
    text-align: center;
    transition: transform 150ms ease;
    &:active {
      transform: scale(0.97);
    }
  }

  .guideHelp {
    width: 100%;
    color: #ff4a7b;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
  }
}

.guideClose {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  background: url("./../../../assets/images/mobileA/guide-close.png") no-repeat;
  background-size: 100% 100%;
}
</style>
